import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
const DEFAULT_LINK_AS = "a";
export const Link = ({ as, children, className, variant = "primary", font, disabled = false, ...rest }) => {
    const ariaDisabled = disabled ? { "aria-disabled": true } : {};
    const Tag = as || DEFAULT_LINK_AS;
    return (_jsx(Tag, { className: classNames("eds-link", {
            [`eds-link--${variant}`]: variant !== "primary",
            [`eds-link--button`]: as === "button",
            [`eds-type--${font}`]: font,
            [`eds-link--disable`]: disabled,
        }, className), ...(disabled && { disabled }), ...ariaDisabled, ...rest, children: children }));
};
